import { render, staticRenderFns } from "./DatasetTaskList.vue?vue&type=template&id=1e9570fb&scoped=true"
import script from "./DatasetTaskList.vue?vue&type=script&lang=js"
export * from "./DatasetTaskList.vue?vue&type=script&lang=js"
import style0 from "./DatasetTaskList.vue?vue&type=style&index=0&id=1e9570fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9570fb",
  null
  
)

export default component.exports